:host {
  display: block;
}
.qumra-input-container{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  background-color: #F8F7F7;
  font-size: small;
  border: 1px solid #E1E1E2; 
  color: #9D9D9D;
  border-radius: 8px;
  height: 144px;
}

.qumra-input{
  display: flex;
  flex-direction: column;
  gap:8px;
  position: relative;
}

.qumra-input-file{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}